import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import DashboardPage from "./pages/DashboardPage";
import PublicLandingPage from "./pages/PublicLandingPage";
import PublicFeaturesPage from "./pages/PublicFeaturesPage";
import PublicAboutPage from "./pages/PublicAboutPage";
import PublicContactPage from "./pages/PublicContactPage";
import TransactionsPage from "./pages/TransactionsPage";
import InvestmentsPage from "./pages/InvestmentsPage";
import EMIPage from "./pages/EMIPage";
import PaymentsPage from "./pages/PaymentsPage";
import BudgetsPage from "./pages/BudgetsPage";
import AIAdvisorPage from "./pages/AIAdvisorPage";
import AlertsPage from "./pages/AlertsPage";
import BankAccountsPage from "./pages/BankAccountsPage";
import LendBorrowPage from "./pages/LendBorrowPage";
import ReportsPage from "./pages/ReportsPage";
import PropertiesPage from "./pages/PropertiesPage";
import MyAccountPage from "./pages/MyAccountPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import api from "./lib/api";
import { Toaster } from "./components/ui/sonner";

function AppContent() {
  const { user } = useAuth();
  const [alertCount, setAlertCount] = useState(0);

  useEffect(() => {
    if (!user) return;
    const fetchAlerts = () => {
      api.get('/alerts').then(r => {
        const unread = (r.data || []).filter(a => !a.read).length;
        setAlertCount(unread);
      }).catch(() => {});
    };
    fetchAlerts();
    const interval = setInterval(fetchAlerts, 30000);
    return () => clearInterval(interval);
  }, [user]);

  return (
    <Routes>
      <Route path="/" element={<PublicLandingPage />} />
      <Route path="/features" element={<PublicFeaturesPage />} />
      <Route path="/about" element={<PublicAboutPage />} />
      <Route path="/contact" element={<PublicContactPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/dashboard" element={<Layout alertCount={alertCount}><DashboardPage /></Layout>} />
      <Route path="/transactions" element={<Layout alertCount={alertCount}><TransactionsPage /></Layout>} />
      <Route path="/stocks" element={<Layout alertCount={alertCount}><InvestmentsPage /></Layout>} />
      <Route path="/banks" element={<Layout alertCount={alertCount}><BankAccountsPage /></Layout>} />
      <Route path="/lendborrow" element={<Layout alertCount={alertCount}><LendBorrowPage /></Layout>} />
      <Route path="/emi" element={<Layout alertCount={alertCount}><EMIPage /></Layout>} />
      <Route path="/payments" element={<Layout alertCount={alertCount}><PaymentsPage /></Layout>} />
      <Route path="/budgets" element={<Layout alertCount={alertCount}><BudgetsPage /></Layout>} />
      <Route path="/properties" element={<Layout alertCount={alertCount}><PropertiesPage /></Layout>} />
      <Route path="/reports" element={<Layout alertCount={alertCount}><ReportsPage /></Layout>} />
      <Route path="/ai-advisor" element={<Layout alertCount={alertCount}><AIAdvisorPage /></Layout>} />
      <Route path="/alerts" element={<Layout alertCount={alertCount}><AlertsPage /></Layout>} />
      <Route path="/my-account" element={<Layout alertCount={alertCount}><MyAccountPage /></Layout>} />
      <Route path="/change-password" element={<Layout alertCount={alertCount}><ChangePasswordPage /></Layout>} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
